<template>
  <div class="btnCont flex-ac flex-c pointer" :class="color">
    <img :src="icon" alt="" v-if="icon" />
    <span>{{ text }}</span>
  </div>
</template>
<script setup>
const props = defineProps({
  text: String,
  icon: String,
  color: String,
});
</script>
<style lang="scss" scoped>
.btnCont {
  width: max-content;
  height: max-content;
  padding: 8px 16px;
  border-radius: 6px;
  background: #4284FF;

  img+span {
    margin-left: 8px;
  }

  span {
    color: #fff;
    font-size: 12px;
    line-height: 12px;
  }

  &:hover {
    cursor: pointer;
    animation: jelly 0.3s;
  }
}

.btnCont.red {
  background: #FC6464;
}

.btnCont.orange {
  background: #FA9F4A;
}

.btnCont.yellow {
  background: #F9D543;
}

.btnCont.green {
  background: #51E26E;
}

.btnCont.blue {
  background: #4284FF;
}

.btnCont.gray {
  background: #9DA2AE;
}

.btnCont+.btnCont {
  margin-left: 16px;
}

@keyframes jelly {

  0%,
  100% {
    transform: scale(1, 1);
  }

  25% {
    transform: scale(0.95, 1.05);
  }

  50% {
    transform: scale(1.05, 0.95);
  }

  75% {
    transform: scale(0.97, 1.02);
  }
}
</style>
